import { render, staticRenderFns } from "./shaixTel.vue?vue&type=template&id=3c8fc894&scoped=true"
import script from "./shaixTel.vue?vue&type=script&lang=js"
export * from "./shaixTel.vue?vue&type=script&lang=js"
import style0 from "./shaixTel.vue?vue&type=style&index=0&id=3c8fc894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8fc894",
  null
  
)

export default component.exports